"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var LivechartsIcon = function LivechartsIcon(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88 85",
    width: props.width || "73px",
    height: props.height || "70px"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", {
    transform: "translate(-106.000000, -108.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(106.000000, 108.000000)"
  }, _react["default"].createElement("path", {
    d: "M87.4407,81.962 C87.4407,83.343 86.3217,84.462 84.9407,84.462 C83.5597,84.462 82.4407,83.343 82.4407,81.962 C82.4407,80.581 83.5597,79.462 84.9407,79.462 C86.3217,79.462 87.4407,80.581 87.4407,81.962",
    fill: props.fill || "#71c4ff"
  }), _react["default"].createElement("path", {
    d: "M78.0032,84.0001 L2.0002,84.0001 C0.8952,84.0001 0.0002,83.1051 0.0002,82.0001 L0.0002,2.0001 C0.0002,0.8951 0.8952,0.0001 2.0002,0.0001 C3.1062,0.0001 4.0002,0.8951 4.0002,2.0001 L4.0002,80.0001 L78.0032,80.0001 C79.1082,80.0001 80.0042,80.8941 80.0042,82.0001 C80.0042,83.1051 79.1082,84.0001 78.0032,84.0001",
    fill: props.fill || "#71c4ff"
  }), _react["default"].createElement("path", {
    d: "M44.0101,60.0028 C43.3831,60.0028 42.7891,59.7078 42.4101,59.2018 L25.5111,36.6718 L11.0691,45.6978 C10.1291,46.2858 8.8971,46.0008 8.3131,45.0628 C7.7271,44.1248 8.0121,42.8908 8.9471,42.3068 L24.9481,32.3058 C25.8351,31.7598 26.9881,31.9718 27.6091,32.8028 L43.7701,54.3498 L60.2691,25.0208 C60.5851,24.4578 61.1541,24.0808 61.7981,24.0128 C62.4451,23.9348 63.0771,24.1888 63.5051,24.6728 L79.5051,42.6738 C80.2401,43.4978 80.1661,44.7638 79.3391,45.4958 C78.5131,46.2308 77.2491,46.1568 76.5171,45.3298 L62.3801,29.4248 L45.7521,58.9828 C45.4221,59.5728 44.8151,59.9538 44.1411,59.9988 C44.0981,60.0008 44.0531,60.0028 44.0101,60.0028",
    fill: props.fill || "#71c4ff"
  }), _react["default"].createElement("path", {
    d: "M64.8392,23.1732 C66.4012,24.7352 66.4012,27.2682 64.8392,28.8302 C63.2772,30.3922 60.7442,30.3922 59.1832,28.8302 C57.6202,27.2682 57.6202,24.7352 59.1832,23.1732 C60.7442,21.6112 63.2772,21.6112 64.8392,23.1732",
    fill: "#FFFFFF"
  }), _react["default"].createElement("path", {
    d: "M62.011,24.0011 C61.478,24.0011 60.976,24.2101 60.597,24.5871 C60.22,24.9661 60.011,25.4681 60.011,26.0011 C60.011,26.5361 60.218,27.0361 60.597,27.4131 C61.357,28.1731 62.671,28.1711 63.423,27.4151 C63.804,27.0361 64.011,26.5361 64.011,26.0011 C64.011,25.4681 63.802,24.9661 63.425,24.5871 L63.423,24.5871 C63.046,24.2081 62.546,24.0011 62.011,24.0011 M62.011,32.0011 C60.409,32.0011 58.902,31.3761 57.768,30.2441 C56.635,29.1131 56.01,27.6051 56.01,26.0011 C56.01,24.3991 56.635,22.8921 57.768,21.7591 C60.036,19.4911 63.99,19.4951 66.253,21.7591 L66.255,21.7591 C67.388,22.8941 68.011,24.3991 68.011,26.0011 C68.011,27.6051 67.386,29.1131 66.253,30.2461 C65.122,31.3761 63.615,32.0011 62.011,32.0011",
    fill: props.fill || "#71c4ff"
  })))));
};

var _default = LivechartsIcon;
exports["default"] = _default;